




























import Component from "vue-class-component";
import BasicForm from "@/layout/form/BasicForm.vue";
import Email from "@/components/inputs/Email.vue";
import {AxiosError, AxiosRequestConfig, AxiosResponse} from "axios";
import Password from "@/components/inputs/Password.vue";
import Loading from "@/components/Loading.vue";
import ErrorMessage from "@/components/messages/ErrorMessage.vue";
import {Vue} from "vue-property-decorator";

class LoginRequestPayload{
    email:String="";
    password:String="";
}

interface LoginResponse{
    key:string;
    url:string;
}
interface ClassicResponse{
    message:string;
}
@Component({
    components: {Password, Email, BasicForm,Loading,ErrorMessage}
})
export default class LoginForm extends Vue {
    loginRequest:LoginRequestPayload = new LoginRequestPayload();
    onFly:boolean=false;
    error:any;

    login(e:Event){
        e.preventDefault();
        this.onFly = true;
        this.$http.post("login",this.loginRequest).then( (response:AxiosResponse)=> {
            this.$store.commit('setUser',response.data.user);
            this.$store.commit('setToken',response.data.token);
            this.$store.dispatch("goHome");
            //this.$store.dispatch("authInit");
            //console.log("end login");
            this.onFly = false;
        }).catch((error:any)=>{
            this.error = error;
            alert(error.toString());
            //alert(this.$helper.errorHandler(error));
            this.onFly = false;
        })
    }
}
